module.exports = __webpack_public_path__ + "images/5657d537391f5f464cddfac70b2b3160-saveR.svg";